export const FETCH_ACTIVITY_SUGGESTIONS = "app/HomeActivityPlanner/FETCH";
export const FETCH_ACTIVITY_SUGGESTIONS_SUCCESS =
  "app/HomeActivityPlanner/FETCH_SUCCESS";
export const FETCH_ACTIVITY_SUGGESTIONS_FAILURE =
  "app/HomeActivityPlanner/FETCH_FAILURE";
export const GENERATE_ACTIVITY_PLAN = "app/HomeActivityPlanner/GENERATE";
export const GENERATE_ACTIVITY_PLAN_DONE =
  "app/HomeActivityPlanner/GENERATE_DONE";
export const ACCEPT_ACTIVITY_SUGGESTION = "app/HomeActivityPlanner/ACCEPT";
export const DISMISS_ACTIVITY_SUGGESTION = "app/HomeActivityPlanner/DISMISS";
export const CONFIRM_DRAFT_ACTIVITY = "app/HomeActivityPlanner/CONFIRM_DRAFT";
export const DISCARD_DRAFT_ACTIVITY = "app/HomeActivityPlanner/DISCARD_DRAFT";
export const REFINE_ACTIVITY_SUGGESTION = "app/HomeActivityPlanner/REFINE";
export const SET_PLANNER_BUSY = "app/HomeActivityPlanner/SET_BUSY";
